import { FunctionComponent } from "react";
import ContentSection from "./ContentSection";
import EcosystemSection from "./EcosystemSection";
import { transformativeSection } from "./data";


const MainContent: FunctionComponent = () => (
  <div className="px-8 py-6 mt-10">
    <TransformativeResultsSection />
    <EcosystemSection />
  </div>
);


const TransformativeResultsSection: FunctionComponent = () => (
  <ContentSection
    title={transformativeSection.title}
    subtitle={transformativeSection.subtitle}
    description={transformativeSection.description}
    linkText={transformativeSection.linkText}
    linkUrl={transformativeSection.linkUrl}
    imageSrc={transformativeSection.imageSrc}
    imageAlt={transformativeSection.imageAlt}
    imagePosition="left"
  />
);


export default MainContent;


